import React from 'react';
import { MenuItems } from './SidebarMenu';
import './Sidebar.css';
import { Link,useLocation, useNavigate } from 'react-router-dom';

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
const userRole = sessionStorage.getItem('userType')
  const getMenuItems = () => {
    switch (userRole) {
      case 'SalesHead':
        return [
          { title: 'Analytics', icon: require("../../Assets/presention-chart.png"), path: '/Analytics' },
          { title: 'Sales', icon: require("../../Assets/presention-chart.png"), path: '/Sales' },
          { title: 'Scheme', icon: require("../../Assets/presention-chart.png"), path: '/Scheme' },
          { title: 'Inventory', icon: require("../../Assets/presention-chart.png"), path: '/SInventory' }
          
        ];
      case 'ClinicalTeam':
        return [
          { title: 'Dashboard', icon: require("../../Assets/presention-chart.png"), path: '/MyDashboard' }
        ];
      case 'FinanceHead':
        return [
          /*{ title: 'F Analytics', icon: require("../../Assets/presention-chart.png"), path: '/FAnalytics' },*/
          { title: 'Analytics', icon: require("../../Assets/presention-chart.png"), path: '/FinanceManagement' },
          { title: 'Inventory', icon: require("../../Assets/presention-chart.png"), path: '/InventoryManagement' },
          { title: 'Primary Order', icon: require("../../Assets/presention-chart.png"), path: '/PurchaseOrder' }
          
        ];
        case 'MarketingHead' : 
        return [
          { title: 'Analytics', icon: require("../../Assets/presention-chart.png"), path: '/MarketingAnalytics' },
          { title: `KPI's`, icon: require("../../Assets/presention-chart.png"), path: '/KPIManagement' },
          { title: 'Events', icon: require("../../Assets/folder-open.png"), path: '/Event' }
        ]
      default:
        return []; 
    }
  };

  const menuItems = getMenuItems();


  return (
    <div className='sidebar'>
        <div className='sidebar-subdiv'>
        <div className="sidebarSub">
            <div className='sidebarLogo'>
                <img src={require('../../Assets/logo.png')} alt="Dacio" />
            </div>
            <div className='sidebarMenuItems'>
               {menuItems.map((items,index)=> (
                <Link key={index} to={items.path} className={`menu-items ${location.pathname === items.path ? 'active' : ''}`}
                >
                   <img className='menu-items-icon' width={24} height={24} src={items.icon} />
                   <span className='menu-items-title'>{items.title}</span>
                </Link>
               ))}
            </div>
        </div>
        <div>
        <div className='sidebar-horizontal'>
         <hr/>
         
        </div>
        <div className='sidebar-logout'>
          <div className={`sidebar-setting ${location.pathname === "/HelpSupport" ? 'active' : ''}`}>
            <img width={24} height={24} src={require("../../Assets/setting-2.png")} alt='' className='sidebar-setting-icon' onClick={()=>navigate("/HelpSupport")} /> 
          </div>
          <div className={`sidebar-message ${location.pathname === "/Setting" ? 'active' : ''}`}>
           <img width={24} height={24} src={require("../../Assets/message.png")} className='sidebar-message-icon' alt='' onClick={()=>navigate("/Help")} />
          </div>
        </div>
        </div>
        </div>
    </div>
  )
}
